<template>
    <div
        v-if="userPoints && userPoints.length > 0"
        :class="containerClass"
    >
        <div
            v-if="userPoints.length === 1 && userPoints[0].is_host"
            class="flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-800"
        >
            <span class="text-slate-600 dark:text-slate-300 text-sm font-medium leading-5">
                Points balance: {{ userPoints[0].formatted_balance }}
            </span>
        </div>

        <template v-else>
            <div
                v-for="userPoint in userPoints"
                :key="userPoint.user_id"
                class="flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-800"
            >
                <Icon icon="user" class="w-5 h-5 text-slate-600 dark:text-slate-300" />
                <span class="text-slate-600 dark:text-slate-300 text-sm font-medium leading-5">
                    {{ userPoint.name }}: {{ userPoint.formatted_balance }} points
                </span>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    userPoints: Array,
    variant: {
        type: String,
        default: 'mobile',
        validator: (v) => ['mobile', 'desktop'].includes(v),
    },
});

const containerClass = computed(() =>
    props.variant === 'desktop'
        ? 'flex pt-6 items-center content-center gap-2 self-stretch flex-wrap'
        : 'mt-4 flex items-center content-center gap-2 flex-wrap'
);
</script>
